























import { Vue, Component, Prop } from 'vue-property-decorator'
import { popup } from '@lx-frontend/cvux'
import { ExitRuleItem } from '../indexType'

@Component({
  components: {
    popup
  }
})
export default class EmployeePopup extends Vue {
  @Prop(Array) readonly list!: ExitRuleItem[];
  @Prop(Array) readonly ids!: number[];

  show = false

  selectIds:number[] = []
  selectName = ''

  selectImg = require('../../../stylesheets/images/select-icon.png')
  notSelectImg = require('../../../stylesheets/images/notselect-icon.png')

  handleSelectCar(id: number) {
    const index = this.selectIds.findIndex(s => s === id)
    if (index !== -1) this.selectIds.splice(index, 1)
    else this.selectIds.push(id)
  }

  changeShow(v:boolean) {
    this.show = v
    if (!v) return
    this.selectIds = JSON.parse(JSON.stringify(this.ids))
  }

  handleSubmit() {
    const { selectIds } = this
    this.$emit('submit', JSON.parse(JSON.stringify(selectIds)))
    this.changeShow(false)
  }
}
